import { apiCall } from "./client";

export async function getStandings(season) {
  const qs = season ? `?season=${encodeURIComponent(season)}` : "";
  return apiCall(`/api/official-matches/standings${qs}`);
}

export async function getPlayoffs(season) {
  const qs = season ? `?season=${encodeURIComponent(season)}` : "";
  return apiCall(`/api/official-matches/playoffs${qs}`);
}
